export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `الوصول اليوم`,
        tomorrow: `الوصول غدًا`,
        this_week: `الوصول هذا الأسبوع`,
        month: `الوصول هذا الشهر`,
        upcoming: `عمليات الوصول القادمة`,
    },
    filtroSalidas: {
        today: `المغادرون اليوم`,
    },
    quitarFiltro: `إزالة الفلتر`,
    // Estancia vendida por horas registrada como reserva
    rapida: `سريع`,
    p1: `الحجوزات`,
    p2: `قائمة الحجوزات المسجلة في المنصة`,
    p3: `المزيد من الإجراءات`,
    p4: `جدولة تسجيل الوصول`,
    p5: `اليوم`,
    p6: `رمز الحجز`,
    p7: `الاسم`,
    p8: `البريد الإلكتروني`,
    p9: `تاريخ الوصول`,
    p10: `الوديعة`,
    p11: `عدد الضيوف`,
    p12: `الحالة: `,
    p13: `الكمية: `,
    p14: `الحالة: `,
    p15: `قيد الانتظار`,
    p16: `مكتمل`,

    p17: `المزيد من الإجراءات`,
    p18: `استيراد الحجوزات`,
    p19: `قم بتنزيل قالب Excel، واملأ بيانات الحجز الخاص بك وقم بتحميله لإنشاء عدة حجوزات في وقت واحد.`,

    p20: `تسجيل وصول مجدول`,
    p21: `معلومات مفصلة عن تسجيل الوصول المجدول`,
    p22: `الحالة: `,
    p23: `مدفوع`,
    p24: `في انتظار الدفع`,
    p25: `تغيير حالة الدفع`,
    p26: `المسؤول عن تسجيل الوصول`,
    p27: `إرسال تسجيل الوصول عبر الإنترنت`,
    p28: `جارٍ إرسال رابط تسجيل الوصول ...`,
    p29: `إرسال تسجيل الوصول عبر الإنترنت إلى الضيوف تلقائيًا`,
    p30: `أسبوع قبل تسجيل الوصول`,
    p31: `72 ساعة قبل تسجيل الوصول`,
    p32: `48 ساعة قبل تسجيل الوصول`,
    p33: `24 ساعة قبل تسجيل الوصول`,
    p34: `حفظ التغييرات`,
    p35: `تاريخ الوصول`,
    p36: `تاريخ المغادرة`,
    p37: `الضيوف المسجلون`,
    p38: `قائمة تسجيلات الوصول المكتملة.`,
    p39: `الاسم`,
    p41: `اللقب`,
    p42: `تاريخ تسجيل الوصول`,
    p43: `البريد الإلكتروني`,
    p44: `العملية`,
    p45: `تم المسح`,
    p46: `يدوي`,
    p47: `مشغل يدوي`,
    p48: `الهاتف`,
    p49: `لا توجد تسجيلات وصول مسجلة`,

    p50: `حالة دفع الحجز`,
    p51: `قم بتغيير حالة دفع الحجز يدويًا.`,
    p52: `اختر أحد الخيارات`,
    p53: `قيد الانتظار`,
    p54: `مدفوع`,
    p55: `إلغاء`,
    p56: `تغيير الحالة`,
    p57: `غير محدد`,
    p58: `مكتمل`,
    p59: `لم يتم تسجيل أي حجوزات بعد`,
    p60: `تسجيلات الوصول المجدولة`,
    p61: `تم حفظ التغييرات بنجاح`,
    p62: `هل تريد إرسال رابط تسجيل الوصول؟`,
    p63: `إرسال الرابط`,
    p64: `إلغاء`,
    p65: `تم إرسال رابط تسجيل الوصول بنجاح`,

    p66: `لم يتم العثور على العقار أو المستخدم.`,
    p67: `خطأ في إنشاء الرمز`,
    p68: `خطأ في الاتصال بالقناة. يرجى المحاولة مرة أخرى.`,
    p69: `التوافر والأسعار`,
    p70: `إدارة الأيام والأسعار المتاحة في مكان إقامتك`,
    p71: `لتنشيط هذه الميزة، تحتاج إلى خطة نشطة. ستتمكن من رؤية توافر مكان إقامتك على الفور، وتغيير الأسعار حسب الموسم أو المناسبات الخاصة، وضبط كل شيء من مكان واحد.`,
    p72: `عند إلغاء هذا الحجز، ستكون التواريخ متاحة في أي بوابة متصلة`,
    p73: `إلغاء الحجز`,
    p74: `تم إلغاء الحجز بنجاح`,
    p75: `حجز `,
    p76: ` تم إلغاؤه.`,
    p77: `لا يمكنك الحجز في تواريخ مغلقة.`,
    p78: `تحقق من التواريخ المختارة`,
    p79: `يجب عليك اختيار ليلة واحدة على الأقل للحجز.`,
    p80: `التواريخ المختارة غير متاحة.`,
    p81: `التذكيرات`,
    p82: `إدارة التذكيرات لضيوفك`,
    p83: `إنشاء تذكير جديد`,
    p84: `اليوم`,
    p85: `الساعة`,
    p86: `الوصف`,
    p87: `حذف التذكير`,
    p88: `لم يتم العثور على تذكيرات مسجلة`,
    p89: `هل أنت متأكد من أنك تريد حذف التذكير؟`,
    p90: `ستفقد البيانات المحفوظة`,
    p91: `حذف التذكير`,
    p92: `تم حذف التذكير بنجاح`,
    p93: `الخطوة الأولى:`,
    p94: `اختر الدولة التي لديك فيها الحجوزات وقم بتنزيل القالب لملء البيانات.`,
    p95: `تنزيل القالب`,
    p96: `الخطوة الثانية:`,
    p97: `قم بتحميل نفس القالب أو القوالب التي قمت بتنزيلها مع البيانات المضافة.`,
    p98: `استيراد`,
    p99: `يجب تحميل الجدول لمتابعة الاستيراد`,
    p100: `تمت العملية بنجاح`,
    p101: `خطأ في عملية الاستيراد`,
    p102: `متاح`,
    p103: `مشغول`,
    p104: `قيد التنظيف`,
    p105: `صيانة`,
    p106: `خطأ في إلغاء الحجز`,
    p107: `خطأ في تحديث العرض بعد الإلغاء`,
    p108: `لم يتم فتح تغيير الغرفة. الحجز غير صالح.`,
    p109: `لم يتم تحديد الغرفة الحالية.`,
    p110: `تم تحديث التوافر بنجاح`,
    p111: `التقويم الفندقي`,
    p112: `إدارة حجوزاتك بصريًا والحفاظ على السيطرة الكاملة على توافر فندقك.`,
    p113: `تغيير التوافر`,
    p114: `إنشاء حجز`,
    p115: `لن يتم إرسال الحجوزات المتوقفة تلقائيًا`,
    p116: `سيتم تفعيل الإرسال التلقائي لهذا الحجز`,
    p117: `إيقاف مؤقت`,
    p118: `تفعيل`,
    p119: `الحجز`,
    p120: `نعم`,
    p121: `تم إيقاف الحجز بنجاح`,
    p122: `تمت العملية بنجاح`,
    p123: `تم تفعيل الحجز بنجاح`,
    p124: `هنا يتم عرض الحجوزات المستلمة من التقويمات المتزامنة وكذلك الحجوزات التي تم إدخالها يدويًا`,
    p125: `تاريخ غير صالح`,
    p126: `تاريخ غير صالح`,
    p127: `سيتم إرسال دعوة تسجيل الوصول في `,
    p128: `حجز متوقف`,
    p129: `تم إلغاء الحجز`,
    p130: `إكمال`,
    p131: `ستظهر هنا جميع حجوزاتك مع تفاصيل كل تسجيل وصول وضيف. عندما يصل حجزك الأول، ستراه هنا مباشرة.`,
    p132: `العقار المختار`,
    p133: `متعدد`,
    p134: `شهري`,
    p135: `مغلق`,
    p136: `تم تحديث التواريخ بنجاح`,
    p137: `خطأ في تحميل بيانات العقار`,
    p138: `التواريخ المختارة غير متاحة. هناك حجوزات أو تواريخ مغلقة تسبب تعارضًا.`,
    p139: `تم إنشاء الحجز بنجاح`,
    p140: `النطاق`,
    p141: `تم الإغلاق بنجاح`,
    p142: `خطأ في حظر التواريخ`,
    p143: `خطأ في حذف التواريخ المغلقة`,
    p144: `تم تحديث الأسعار بنجاح`,
    p145: `خطأ في تحديث الأسعار`,
    p146: `هل أنت متأكد من أنك تريد إلغاء هذا الحجز؟`,
    p147: `تأكيد الإلغاء`,
    p148: `نعم، إلغاء`,
    p149: `لا`,
    p150: `تم إلغاء الحجز بنجاح`,
    p151: `خطأ في تحميل العقارات`,
    p152: `تمت إضافة حجز جديد إلى التقويم`,
    p153: `هذا الحجز يأتي من قناة خارجية (OTA). لا يُنصح بإلغائه مباشرة من هذا النظام. يرجى التواصل مع الضيف وطلب إلغاء الحجز من خلال القناة الأصلية التي تم من خلالها الحجز.`,
    p154: `حجز OTA - الإلغاء غير مسموح`,
    p155: `مفهوم`,
    p156: `خطأ في معالجة الطلب`,
    p157: `تم نسخ الرابط بنجاح`,
    p158: `تم النسخ!`,
    p159: `حدث خطأ أثناء نسخ الرابط`,
    p160: `خطأ`,
    p161: `إرسال تسجيل الوصول إلى المسؤول عن الحجز`,
    p162: `إرسال تسجيل الوصول`,
    p163: `إرسال`,
    p164: `خطأ في تحميل الحجز`,
    p165: `معلومات تسجيل الوصول`,
    p166: `إرسال طلب تسجيل الوصول`,
    p167: `جميع الحجوزات`,
    p168: `الحجوزات القادمة`,
    p169: `الحجوزات الملغاة`,
    p170: ``,
    p171: `تاريخ تسجيل الوصول`,
    p172: `تسجيل الوصول`,
    p173: `محجوز`,
    p174: `حجز زائد`,
    p175: `ملغى`,
    p176: ``,
    p177: ``,
    p178: ``,
    p179: ``,
    p180: ``,
    p181: ``,
    p182: ``,
    p183: ``,
}